import { render, staticRenderFns } from "./PatientSidebarSkeleton.vue?vue&type=template&id=d4002f36&scoped=true"
import script from "./PatientSidebarSkeleton.vue?vue&type=script&lang=js"
export * from "./PatientSidebarSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PatientSidebarSkeleton.vue?vue&type=style&index=0&id=d4002f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4002f36",
  null
  
)

export default component.exports